import classNames from 'classnames'

import Image from '../ui/Image/Image'
import JoiningCard from '../ui/JoinningCard/JoinningCard'
import ContactListing from '../ui/ContactListing/ContactListing'
import { getImageUrl } from '../../utils'

import UpArrow from '../../assets/images/arrowUpRight.svg'
import styles from './ContactUsCard.module.scss'

function ContactUsCard({ contactData, handleView }) {
  const sectiondata = contactData?.sectiondata
  const hideContactForm = contactData?.hidecontactform

  const section1 = sectiondata?.section1
  const section2 = sectiondata?.section2
  const section3 = sectiondata?.section3
  return (
    <>
      {!hideContactForm && section1 && (
        <div className="page-container">
          <div
            className={classNames(
              styles['container'],
              'grid grid-cols-1 md:grid-cols-2 '
            )}
          >
            <div className={styles.helpcard}>
              <p className={styles.title}>{section1?.title}</p>
              <p className={styles.subTitle}>{section1?.description}</p>
              <button
                className="flex flex-row items-center"
                onClick={() => handleView && handleView()}
              >
                <span className={styles.sendTxt}>{section1?.link?.label}</span>
                <Image
                  src={UpArrow}
                  alt={section1?.link?.label}
                  className={classNames(
                    styles['action-image'],
                    'block cursor-pointer'
                  )}
                />
              </button>
            </div>
            <div className={classNames(styles['cardOne'])}>
              <Image
                src={getImageUrl(section1?.image)}
                alt={section1?.image?.alternativeText}
                className={styles.cardOneImg}
              />
            </div>
          </div>
          <hr className="my-8 sm:my-20" />
        </div>
      )}
      <ContactListing section2={section2} />
      {section3 && <JoiningCard section3={section3} />}
    </>
  )
}

export default ContactUsCard
